import { render } from "./DashboardTable.vue?vue&type=template&id=4aa4c1b6&scoped=true"
import script from "./DashboardTable.vue?vue&type=script&lang=js"
export * from "./DashboardTable.vue?vue&type=script&lang=js"

import "./DashboardTable.vue?vue&type=style&index=0&id=4aa4c1b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa4c1b6"]])

export default __exports__